import rawStateData from './naspoRawStateData.json';
import { NaspoStateProfile } from '../types/naspo';

export const NASPO_RAW_STATES: Record<string, NaspoStateProfile> = rawStateData as unknown as Record<string, NaspoStateProfile>;

export const ALL_NASPO_STATES: NaspoStateProfile[] = Object.values(NASPO_RAW_STATES).sort((a, b) => 
  a.state.localeCompare(b.state)
);

export function getNaspoStateByCode(code: string): NaspoStateProfile | undefined {
  if (!code) return undefined;
  const upper = code.toUpperCase();
  return NASPO_RAW_STATES[upper] || ALL_NASPO_STATES.find(s => s.stateCode.toUpperCase() === upper);
}

export function getNaspoStateByName(name: string): NaspoStateProfile | undefined {
  if (!name) return undefined;
  const lower = name.toLowerCase().trim();
  return ALL_NASPO_STATES.find(s => 
    s.state.toLowerCase() === lower || 
    s.stateCode.toLowerCase() === lower
  );
}

export const NASPO_REGIONS = ['All', 'Eastern', 'Midwestern', 'Southern', 'Western'] as const;
export type NaspoRegionFilter = typeof NASPO_REGIONS[number];
